import React from 'react'
import get from 'lodash/get'
import { i18n } from '../../index'
import { Query } from 'react-apollo'
import { Typography } from '@mui/material'
import Loader from '../../../common/loader/Loader'
import ThumbableServicePage from './ThumbableServicePage'
import { fetchThumbableServices } from './thumbableServiceQueries'
import type { ThumbableService } from './thumbableServiceTypes'
import css from './thumbableServicePage.css'

const ChainThumbableServicePage = () => (
  <div>
    <div className={css.top}>
      <Typography variant='h6'>{i18n.t('admin.thumbableServices.pageTitle')}</Typography>
    </div>
    <Query<
      {
        thumbsUpItems: Array<ThumbableService>
      },
      Record<string, any>
    >
      query={fetchThumbableServices}
    >
      {({ loading, error, data }) => (
        <Loader
          {...{
            loading,
            error,
          }}
        >
          <ThumbableServicePage data={get(data, 'thumbsUpItems', [])} />
        </Loader>
      )}
    </Query>
  </div>
)

export default ChainThumbableServicePage
